import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import H1 from '../../Atoms/H1';
import Section from '../../Atoms/Section';
import H2 from '../../Atoms/H2';
import BoldBlue from '../../Atoms/BoldBlue';
import { SDE2024MultiSelectOptionsA } from '../../Utils/Listings';
import { makeUrlsAndEmailsLinks } from '../../Utils/Format';

const ProjectContainer = styled.div`
    background-color: #F6F6F6;
    border-radius: 20px;
    padding: 20px;
    margin: 20px 0;
`

function valuesToString(value, options) {
    //make sure value is an array
    if (!Array.isArray(value)) {
        value = [value];
    }
    const optionsFlattened = []
    for (let i = 0; i < options.length; i++) {
        if (options[i].options) {
            optionsFlattened.push(...options[i].options);
        }
        if (options[i].value) {
            optionsFlattened.push(options[i]);
        }
    }
    return optionsFlattened.filter(opt => value.includes(opt.value)).map(opt => opt.label).join(', ')
}

const CompanyMoreInformation = (props) => {

    const { i18n } = useTranslation('common');

    const [specialite, setSpecialite] = React.useState("");

    const eventInscriptionFinished = props.event?.inscriptions_end_date && new Date(props.event.inscriptions_end_date).setHours(23, 59, 59) < new Date();

    const archiIntList = SDE2024MultiSelectOptionsA.archiIntListA(i18n.language);
    const critereList = SDE2024MultiSelectOptionsA.critereListA(i18n.language);
    const rechercheProcess = SDE2024MultiSelectOptionsA.rechercheProcessA(i18n.language);
    const rechercheProduction = SDE2024MultiSelectOptionsA.rechercheProductionA(i18n.language);
    const rechercheFlex = SDE2024MultiSelectOptionsA.rechercheFlexA(i18n.language);
    const rechercheModel = SDE2024MultiSelectOptionsA.rechercheModelA(i18n.language);
    const artisanatType = SDE2024MultiSelectOptionsA.artisanatTypeA(i18n.language);
    const artisanatScale = SDE2024MultiSelectOptionsA.artisanatScaleA(i18n.language);
    const artisanatExport = SDE2024MultiSelectOptionsA.artisanatExportA(i18n.language);
    const mobilierType = SDE2024MultiSelectOptionsA.mobilierTypeA(i18n.language);
    const mobilierExport = SDE2024MultiSelectOptionsA.mobilierExportA(i18n.language);
    const mobilierMaterial = SDE2024MultiSelectOptionsA.mobilierMaterialA(i18n.language);
    const mobilierScale = SDE2024MultiSelectOptionsA.mobilierScaleA(i18n.language);

    // compute specialite
    React.useEffect(() => {
        //console.log(props.company)
        if(!props.company || props.company.participation.type?.substring(0,3) === "sdo" || !partData) return;
        
        let _specialite = [];

        if(typeof partData.archi === "string"){
            let archis = partData.archi.split(';').map(code => {
                if(code === "archi_commerce") return "commerce et retail"
                if(code === "archi_hotels") return "hotels, restaurants"
                if(code === "archi_residences") return "résidences particuliers"
                if(code === "archi_equipements") return "équipements publics"
                if(code === "archi_sceno") return "scénographie et décoration"
                return ""
            }).filter(val => val).join(', ')
            _specialite = _specialite.concat(archis);
        }
        _specialite.push(partData.archi_autre)
        if(typeof partData.donneur === "string"){
            let donneurs = partData.donneur.split(';').map(code => {
                if(code === "donneur_cabinet") return "cabinet d'architecture"
                if(code === "donneur_promotion") return "promotion immobiliere"
                if(code === "donneur_groupe") return "groupe hotelier/restauration"
                if(code === "donneur_space") return "space planner"
                if(code === "donneur_operateur") return "opérateur de coworking/coliving"
                return ""
            }).filter(val => val).join(', ')
            _specialite = _specialite.concat(donneurs);
        }
        _specialite.push(partData.donneur_autre)

        setSpecialite(_specialite.join('\n'));
        
    },[props.company]);

    const partData = props.company?.participation?.data;

    return (
        <div className='moreinfo'>
            <Section className='padding'>
                {props.onBack && <span className='linkbutton' onClick={props.onBack}>← {i18n.language === "fr" ? "Retour" : "Back"}</span>}<br/>
            </Section>
            {props.company && <>
                <Section className='padding'>
                    {props.company.company.logo && <img alt="" className='logosized' src={process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + props.company.company.logo}/>}
                    <H1>{props.company.hsCompany?.properties?.name}</H1>
                    <p className='thin'>{props.company.hsProfile.city}, {props.company.hsProfile.country || "France"}</p>
                </Section>
                {props.company.participation.type.substring(0,3) === "sdo" && <>
                    <Section className='padding'>
                        <H2><strong>{i18n.language === "fr" ? "Présentation de l'entreprise" : "Company presentation"}</strong></H2><br/>
                        <p className='preformatted'>{i18n.language === "fr" ? props.company.hsCompany.properties?.description_courte_fr : props.company.hsCompany.properties?.description_courte_en }</p><br/>
                        <BoldBlue>{i18n.language === "fr" ? "Positionnement :" : "positioning:"} </BoldBlue><span className='thin'>{props.company.hsCompany.properties?.positionnement?.split(';').join(', ')}</span><br/><br/>
                        <BoldBlue>{i18n.language === "fr" ? "Clientèle :" : "Customer base:"} </BoldBlue><span className='thin'>{props.company.hsCompany.properties?.clientele?.split(';').join(', ')}</span>
                    </Section>
                    <Section className='padding'>
                        <H2><strong>{i18n.language === "fr" ? "Besoins et recherches" : "Needs"}</strong></H2><br/>
                        <BoldBlue>{i18n.language === "fr" ? "Offre (typologie de mobiliers / objets / produits) :" : "Offer (typology of furniture / objects / products):"}</BoldBlue> <span className='thin'>{partData.offre}</span><br/><br/>
                        <BoldBlue>{i18n.language === "fr" ? "Savoir-faire, matériaux et techniques :" : "Know-how, materials and techniques:"}</BoldBlue> <span className='thin'>{partData.savoir_faire}</span><br/><br/>
                    </Section>
                    {partData.projets?.length > 0 && <>
                        <Section className='padding'>
                            <H2><strong>{i18n.language === "fr" ? "Projets" : "Projects"}</strong></H2><br/>
                        
                            {partData.projets?.map((p,i) => 
                                <ProjectContainer key={i}>
                                    <BoldBlue>{i18n.language === "fr" ? "Description du projet :" : "Project description:"} </BoldBlue><span className='thin' style={{whiteSpace:"pre-wrap"}}>{makeUrlsAndEmailsLinks(p.description)}</span><br/><br/>
                                    <BoldBlue>{i18n.language === "fr" ? "Typologie(s) de mobiliers/objets/produits :" : "Type(s) of furniture/objects/products:"} </BoldBlue><span className='thin'>{p.typologie}</span><br/><br/>
                                    <BoldBlue>{i18n.language === "fr" ? "Savoir-faire, matériaux et techniques :" : "Know-how, materials and techniques:"} </BoldBlue><span className='thin'>{p.savoirfaire}</span><br/><br/>
                                    <BoldBlue>{i18n.language === "fr" ? "Profil du créateur recherché :" : "Profile details of required designer:"} </BoldBlue><span className='thin'>
                                        {p.dp && "Designer produit"}
                                        {p.dpetai && "Designer produit et architecte d'intérieur"}
                                        {p.da && "Directeur artistique"}
                                    </span><br/><br/>
                                    {p.precision && <><BoldBlue>{i18n.language === "fr" ? "Précision sur le profil du créateur recherché :" : "Profile details of required designer:"} </BoldBlue><span className='thin'>{p.precision}</span><br/><br/></>}
                                </ProjectContainer>
                            )}
                        </Section>
                    </>}
                </>}
                {props.company.participation.type.substring(0,3) === "sde" && <>
                    <Section className='padding'>
                        <H2><strong>{i18n.language === "fr" ? "Présentation de l'entreprise" : "Company presentation"}</strong></H2><br/>
                        <p className='preformatted'>{i18n.language === "fr" ? props.company.hsCompany.properties?.description_courte_fr : props.company.hsCompany.properties?.description_courte_en }</p><br/>
                        <BoldBlue>{i18n.language === "fr" ? "Profils / Spécialités :" : "Area of expertise:"} </BoldBlue><span className='thin'>{valuesToString(partData.type_projets, archiIntList)}</span><br/><br/>
                        <BoldBlue>{i18n.language === "fr" ? "Positionnement :" : "positioning:"} </BoldBlue><span className='thin'>{props.company.hsCompany.properties?.positionnement?.split(';').join(', ')}</span><br/><br/>
                        <BoldBlue>{i18n.language === "fr" ? "Clientèle :" : "Customer base:"} </BoldBlue><span className='thin'>{props.company.hsCompany.properties?.clientele?.split(';').join(', ')}</span>
                    </Section>
                    <Section className='padding'>
                        <H2><strong>{i18n.language === "fr" ? "Besoins et recherches" : "Needs"}</strong></H2><br/>
                        <BoldBlue>{i18n.language === "fr" ? "Profils de sociétés recherchés :" : "Type of companies sought:"}</BoldBlue> <span className='thin'>
                                {valuesToString(partData.criteres, critereList)}
                        </span>
                        {partData.criteres_precisions && <><br/><br/>{partData.criteres_precisions}<br/><br/></>}
                        <div className="flexblock" style={{alignItems:"flex-start"}}>
                            <div style={{minWidth:"300px"}}>
                                <strong>{i18n.language === "fr" ? "Types d’offres et de savoir-faire recherchés :" : "Types of offers and skills sought:"} </strong><br/><br/>
                                {partData.artisanatType && <><BoldBlue>{i18n.language === "fr" ? "Artisanat d'art" : "Arts and crafts"} :</BoldBlue><br/><br/>
                                    <div className='decal'>
                                        <BoldBlue>{i18n.language === "fr" ? "Type de savoir-faire" : "Type of skills"} :</BoldBlue> <span className='thin'>
                                            {valuesToString(partData.artisanatType, artisanatType)}
                                        </span><br/><br/>
                                        <BoldBlue>{i18n.language === "fr" ? "Échelle de production" : "Scale of production"} :</BoldBlue> <span className='thin'>
                                            {valuesToString(partData.artisanatScale, artisanatScale)}
                                        </span><br/><br/>
                                        <BoldBlue>{i18n.language === "fr" ? "Projets à l'export" : "Projects for export"} :</BoldBlue> <span className='thin'>
                                            {valuesToString(partData.artisanatExport, artisanatExport)}
                                        </span>
                                        {partData.artisanat_precisions && <><br/><br/>{partData.artisanat_precisions}<br/><br/></>}
                                    </div>
                                </>}
                                {partData.mobilierType && <><BoldBlue>{i18n.language === "fr" ? "Mobilier" : "Furniture"} :</BoldBlue><br/><br/>
                                    <div className='decal'>
                                        <BoldBlue>{i18n.language === "fr" ? "Type de mobilier" : "Type of furniture"} :</BoldBlue> <span className='thin'>
                                            {valuesToString(partData.mobilierType, mobilierType)}
                                        </span><br/><br/>
                                        <BoldBlue>{i18n.language === "fr" ? "Type de matériaux" : "Type of materials"} :</BoldBlue> <span className='thin'>
                                            {valuesToString(partData.mobilierMaterial, mobilierMaterial)}
                                        </span><br/><br/>
                                        <BoldBlue>{i18n.language === "fr" ? "Echelle de production" : "Scale of production"} :</BoldBlue> <span className='thin'>
                                            {valuesToString(partData.mobilierScale, mobilierScale)}
                                        </span><br/><br/>
                                        <BoldBlue>{i18n.language === "fr" ? "Projets à l'export" : "Projects for export"} :</BoldBlue> <span className='thin'>
                                            {valuesToString(partData.mobilierExport, mobilierExport)}
                                        </span>
                                        {partData.mobilier_precisions && <><br/><br/>{partData.mobilier_precisions}<br/><br/></>}
                                    </div>
                                </>}
                            </div>
                            <div style={{minWidth:"300px"}}>
                                <strong>{i18n.language === "fr" ? "Savoir-faire sur la thématique du design durable recherchés :" : "Skills in sustainable design sought:"} </strong><br/><br/>
                                <BoldBlue>{i18n.language === "fr" ? "Nouveaux modèles de l'économie circulaire" : "New circular economy models"} :</BoldBlue> <span className='thin'>
                                    {valuesToString(partData.rechercheModel, rechercheModel)}
                                </span><br/><br/>
                                <BoldBlue>{i18n.language === "fr" ? "Process innovants" : "Innovative processes"} :</BoldBlue> <span className='thin'>
                                    {valuesToString(partData.rechercheProcess, rechercheProcess)}
                                </span><br/><br/>
                                <BoldBlue>{i18n.language === "fr" ? "Flexibilité d'usage" : "Flexibility of use"} :</BoldBlue> <span className='thin'>
                                    {valuesToString(partData.rechercheFlex, rechercheFlex)}
                                </span><br/><br/>
                                <BoldBlue>{i18n.language === "fr" ? "Production locale" : "Local production"} :</BoldBlue> <span className='thin'>
                                    {valuesToString(partData.rechercheProduction, rechercheProduction)}
                                </span>
                                {partData.recherche_precisions && <><br/><br/>{partData.recherche_precisions}<br/><br/></>}
                            </div>
                        </div>
                    </Section>
                    <Section className='padding'>
                        <H2><strong>{i18n.language === "fr" ? "Projets en cours / à venir" : "Current / upcoming projects"}</strong></H2><br/>
                        {partData.projets?.filter(p => p.title).map((p,i) =>
                            <div key={i}>
                                {i + 1}. {p.title}<br/>
                                Type : {p.type}<br/>
                                {p.country}, {p.city}<br/>
                                <br/>
                            </div>
                        )}
                    </Section>
                </>}
                {!props.hideBottomStuff && <Section className='padding'>
                    {props.onBack && <span className='linkbutton' onClick={props.onBack}>← {i18n.language === "fr" ? "Retour" : "Back"}</span>}<br/>
                    {props.showCandidateButton && !props.candidaturesMaxed && !eventInscriptionFinished && <button className='centered' onClick={props.onCandidate}>{i18n.language === "fr" ? "CANDIDATER POUR UN RENDEZ-VOUS" : "Apply"}</button>}
                    {!props.showCandidateButton && !props.candidaturesMaxed && <i className='thin centered'>{i18n.language === "fr" ? "Vous avez déjà candidaté à cette entreprise" : "You have already applied to this company"}</i>}
                    {props.candidaturesMaxed && <i className='thin centered'>{i18n.language === "fr" ? "Vous avez déjà candidaté au nombre maximum d'entreprises" : "You have already applied to the maximum number of companies"}</i>}
                    {eventInscriptionFinished && <i className='thin centered'>{i18n.language === "fr" ? "Les candidatures sont terminées" : "Applications are closed"}</i>}
                </Section>}
            </>}
        </div>
    );
};

export default CompanyMoreInformation;